import * as React from 'react';

function ExcelIcon(props) {
  return (
    <svg width="40" height="40" viewBox="0 0 36 35.343" {...props}>
      <path
        // eslint-disable-next-line max-len
        d="M35.329 4.324h-12.06v2.232h3.555v3.531h-3.555v1.125h3.555v3.535h-3.555v1.156h3.555v3.344h-3.555v1.34h3.555v3.351h-3.555v1.34h3.555v3.371h-3.555v2.458h12.06c.19-.057.349-.282.477-.672A3.289 3.289 0 0036 29.48V4.732c0-.192-.066-.307-.194-.348a1.65 1.65 0 00-.477-.06zm-1.564 24.321h-5.786v-3.367h5.785v3.368zm0-4.707h-5.786v-3.352h5.785zm0-4.692h-5.786v-3.328h5.785v3.329zm0-4.5h-5.786v-3.531h5.785v3.531zm0-4.679h-5.786V6.558h5.785v3.513zM0 3.771v27.9l21.24 3.674V0L0 3.78zm12.59 21.1q-.122-.328-1.137-2.795c-.674-1.644-1.08-2.6-1.2-2.874h-.038l-2.277 5.426-3.045-.205 3.612-6.752L5.2 10.923l3.1-.163 2.052 5.281h.04l2.318-5.521 3.208-.2-3.82 7.3 3.94 7.451-3.448-.2z"
        fill="#227447"
      />
    </svg>
  );
}

export default ExcelIcon;
